import React from 'react';
import { useAuth } from '../auth/AuthContext';
import LoadingScreen from './LoadingScreen';
import RedirectToApex from '../auth/RedirectToApex';

/**
 * ProtectedRoute - Controls access based on user's membership plan.
 * 
 * @param {React.Element} element - The component to render if access is allowed.
 * @param {Array} allowedMemberships - (Optional) Array of allowed membership levels like ['standard', 'pro', 'owner']
 */
const ProtectedRoute = ({ element, allowedMemberships }) => {
  const { user, loading } = useAuth();

  if (loading) return <LoadingScreen />;

  // Not signed in → the apex is the only login surface, so bounce there (carrying
  // a return URL) rather than rendering a local login card.
  if (!user) {
    console.warn("⛔ User not found. Redirecting to apex login.");
    return <RedirectToApex to="/login" />;
  }

  const userMembership = user['custom:membership'] || 'standard';

  if (allowedMemberships && allowedMemberships.length > 0 && !allowedMemberships.includes(userMembership)) {
    console.warn(`⛔ Access Denied. User membership (${userMembership}) not allowed. Redirecting to apex login.`);
    return <RedirectToApex to="/login" />;
  }

  return element;
};

export default ProtectedRoute;
